import { TokenContext } from './evaluateTemplateExpression'
import { evaluateTemplateExpression } from './evaluateTemplateExpression'

/**
 * Evaluates a schema property value, resolving any template expressions if the value is a string or array.
 * Non-string/non-array values pass through unchanged.
 *
 * This function is applied recursively to all schema property values during schema resolution.
 *
 * @example
 * evaluateSchemaProperty("${year - 1}-04-16", tokenContext) => "2023-04-16"
 * evaluateSchemaProperty({ minimum: "${year - 1920}" }, tokenContext) => { minimum: 104 } (recursive)
 * evaluateSchemaProperty(100, tokenContext) => 100 (unchanged)
 */
export function evaluateSchemaProperty(
  value: unknown,
  tokenContext?: TokenContext
): unknown {
  return evaluateTemplateExpression(value, tokenContext)
}
